require('../../core/require-theme.js');
require('./page.css');
